(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("rxjs/Observable"), require("@angular/common"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "rxjs/Observable", "@angular/common"], factory);
	else if(typeof exports === 'object')
		exports["angular-formio"] = factory(require("@angular/core"), require("rxjs/Observable"), require("@angular/common"));
	else
		root["angular-formio"] = factory(root["ng"]["core"], root["Rx"], root["ng"]["common"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_149__, __WEBPACK_EXTERNAL_MODULE_210__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition